module.exports = __webpack_public_path__ + "img/img-card-4.1cb599b4.png";